import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ArticleModel } from 'src/models/article.model';

@Injectable({
  providedIn: 'root'
})
export class ArticleService {

  constructor(private http: HttpClient) { }

  list(): Observable<Array<ArticleModel>> {
    return this.http.get(`${environment.apiUrl}article/`) as Observable<Array<ArticleModel>>;
  }

  limit(): Observable<Array<ArticleModel>> {
    return this.http.get(`${environment.apiUrl}article/limit/`) as Observable<Array<ArticleModel>>;
  }

  retrieve(slug: string): Observable<ArticleModel> {
    return this.http.get(`${environment.apiUrl}article/${slug}/`) as Observable<ArticleModel>;
  }
}
